

const bowlingShoes =  [
  {
    id: 1,
    shoeName: "Vapor",
    color: "2-Color, Black/Silver, White/Black",
    size: "7-12, 13, 14",
    description: "Perfomance synthetic uppers.  Foam Padded collar and tongue.  Extra-light molded EVA outside. Pure slide microfiber slide soles on both shoes.  Superior slide immediately",
    price: 65.95,
    imgFull:"http://shop.bowlersparadise.com/media/extendware/ewimageopt/media/inline/e/c/brunswick-vapor-black-silver-mens-bowling-shoes-2f3.png",
    imgFull2: "http://cdn2.bigcommerce.com/server1600/e12a1/images/stencil/1000x1000/products/5047/21835/58201110XXX_Vapor_White-Black_Side_1600x1600__69174.1470780018.jpg?c=2"
  },
  {
    id: 2,
    shoeName: "Rampage",
    color: "1-Color, Black",
    size: "wide 8-12, 13, 14",
    description: "Value priced!. Synthetic uppers. Customizable slide sole technology. Rubber push away.  Includes 2 slide soles, and upgraded insole for comfort",
    price: 35.95,
    imgFull:"http://www.bowlerx.com/images/rampage7.jpg",
    imgFull2: "http://www.bowlerx.com/images/rampage2.jpg"
  },
  {
    id: 3,
    shoeName: "Team Brunswick Men's",
    color: "1-Color, Black",
    size: "RH or LH 8-12, 13, 14",
    description: "Soft full grain leather.  Stitch-down construction.  Leather toe protector.  Premium comfort insole.  Musti-zone push away rubber.  Right or left hand specific sizes",
    price: 95.95,
    imgFull:"http://www.bowlerx.com/images/1497558028550960689317.jpeg",
    imgFull2: "https://www.buddiesproshop.com/custom/assets/images/product/58501101XXX_Team_Brunswick_Mens_sole-right_1600x1600.jpg"
  },


];

export default bowlingShoes;



// WEBPACK FOOTER //
// ./src/data/bowlingShoe.js